import type { ReactElement } from 'react';
import type { PieChartArc } from './piechart-types';
interface PieChartSvgDefsProps {
    arcs: ReadonlyArray<PieChartArc>;
    pieChartIdPrefix: string;
}
export function PieChartSvgDefs({ arcs, pieChartIdPrefix, }: PieChartSvgDefsProps): ReactElement {
    return (
      <defs>
        <filter id={`${pieChartIdPrefix}-glow`} x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="5"/>
        </filter>
        {arcs.map((arc, index) => (<linearGradient key={arc.debugIdentity} id={`${pieChartIdPrefix}-gradient-${index}`} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={arc.color}/>
            <stop offset="100%" stopColor={arc.color} stopOpacity={0.6}/>
          </linearGradient>))}
      </defs>
    );
}
